import {BadgeColorScheme} from 'platform/components';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {CarPassState} from './deriveCarPassState';

export const getStateBadge = (uiState: CarPassState) =>
  match<CarPassState, {colorScheme: BadgeColorScheme; value: string}>(uiState)
    .with(CarPassState.NONE, () => ({
      colorScheme: 'neutral',
      value: i18n.t('page.carPass.labels.pillNone'),
    }))
    .with(CarPassState.PENDING, () => ({
      colorScheme: 'orange',
      value: i18n.t('page.carPass.labels.pillPending'),
    }))
    .with(CarPassState.WAITING_FOR_DIV, () => ({
      colorScheme: 'orange',
      value: i18n.t('page.carPass.labels.pillWaitingForDiv'),
    }))
    .with(CarPassState.ACTION_REQUIRED, () => ({
      colorScheme: 'red',
      value: i18n.t('page.carPass.labels.pillActionRequired'),
    }))
    .with(CarPassState.ACTION_TAKEN, () => ({
      colorScheme: 'orange',
      value: i18n.t('page.carPass.labels.pillActionTaken'),
    }))
    .with(CarPassState.READY, () => ({
      colorScheme: 'green',
      value: i18n.t('page.carPass.labels.pillReady'),
    }))
    .with(CarPassState.EXPIRED, () => ({
      colorScheme: 'neutral',
      value: i18n.t('page.carPass.labels.pillExpired'),
    }))
    .with(CarPassState.FAILED, () => ({
      colorScheme: 'red',
      value: i18n.t('page.carPass.labels.pillFailed'),
    }))
    .exhaustive();
